query getLeadsPipelineStatuses($isMasterView: Boolean, $childCompanyId: ID) {
  leadsPipelineStatuses: getLeadsPipelineStatuses(isMasterView: $isMasterView, childCompanyId: $childCompanyId) {
    id
    companyId
    name
    position
  }
}
